const carouselItems = [
  {
    title: '暑期影视狂欢季',
    desc: '2026暑期档全面爆发，多部重量级影片与热门剧集集中上映，从大银幕到小屏幕，精彩内容不容错过。我们为您梳理了本季最值得期待的作品清单。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20premiere%20outdoor%20venue%20with%20warm%20golden%20sunset%20lighting%20cinematic%20wide%20composition%20entertainment%20event%20atmosphere%20sophisticated%20editorial%20photography&width=700&height=450&seq=carousel-item-01&orientation=landscape',
    tag: '影视',
  },
  {
    title: '年度音乐盛典前瞻',
    desc: '各大音乐颁奖礼即将拉开帷幕，提名名单引发乐迷热议。从流行到独立，从新人到天王天后，谁将捧起年度奖杯？',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20scene%20with%20warm%20atmospheric%20stage%20lighting%20concert%20vibe%20energetic%20entertainment%20atmosphere%20wide%20composition%20professional%20photography&width=700&height=450&seq=carousel-item-02&orientation=landscape',
    tag: '音乐',
  },
  {
    title: '红毯造型年度精选',
    desc: '回顾过去一年各大活动红毯上的惊艳造型，从华丽礼服到个性穿搭，看看哪些明星的时尚品味最受好评。',
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20award%20ceremony%20entrance%20with%20photographers%20and%20glamorous%20warm%20lighting%20celebrity%20culture%20atmosphere%20wide%20editorial%20composition&width=700&height=450&seq=carousel-item-03&orientation=landscape',
    tag: '时尚',
  },
  {
    title: '下半年重磅推荐',
    desc: '展望下半年，娱乐圈将迎来更多值得期待的影视作品、综艺节目与音乐专辑。我们精选了最受关注的即将上线内容，帮您提前锁定追剧清单。',
    image: 'https://readdy.ai/api/search-image?query=Streaming%20entertainment%20platform%20concept%20with%20modern%20digital%20interface%20design%20warm%20ambient%20lighting%20technology%20lifestyle%20atmosphere%20editorial%20photography&width=700&height=450&seq=carousel-item-04&orientation=landscape',
    tag: '前瞻',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              深度聚焦娱乐圈最值得关注的专题内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01] border border-background-200/60"
              >
                <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}